<template>
  <v-card class="mb-30">
    <v-card-text class="pa-8 text-center">
      <v-avatar color="warning" size="80" class="mb-4">
        <i class="material-icons-round text-white" style="font-size: 48px;">lock</i>
      </v-avatar>
      <h3 class="text-h4 font-weight-bold text-typo mb-3">
        Keine Berechtigung
      </h3>
      <p class="text-body-1 text-muted mb-4">
        {{ message || 'Du benötigst die entsprechenden Rechte, um auf diese Seite zuzugreifen.' }}
      </p>
      <p class="text-body-2 text-muted mb-6">
        Wenn Du glaubst, dass dies ein Fehler ist, wende Dich bitte an den System-Administrator.
      </p>
      <v-btn
        v-if="allowedRoute"
        class="bg-gradient-primary text-white"
        large
        @click="goToAllowedArea"
      >
        <i class="material-icons-round me-2">{{ allowedIcon }}</i>
        {{ allowedButtonText }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PermissionDenied',
  props: {
    message: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isManager',
      'isPosUser',
      'isChecker'
    ]),
    
    // Determine the first allowed route for this user
    allowedRoute() {
      if (this.isAdmin || this.isManager) {
        return '/admin/analytics';
      } else if (this.isPosUser) {
        return '/admin/pos/create-ticket';
      } else if (this.isChecker) {
        return '/'; // Checker zur Website (Scanner nur in App)
      }
      return null;
    },
    
    allowedButtonText() {
      if (this.isAdmin || this.isManager) {
        return 'Zum Dashboard';
      } else if (this.isPosUser) {
        return 'Zu POS-Tickets';
      } else if (this.isChecker) {
        return 'Zur Website'; // Scanner nur in App verfügbar
      }
      return 'Zurück';
    },
    
    allowedIcon() {
      if (this.isAdmin || this.isManager) {
        return 'dashboard';
      } else if (this.isPosUser) {
        return 'point_of_sale';
      } else if (this.isChecker) {
        return 'home'; // Home statt Scanner-Icon
      }
      return 'arrow_back';
    }
  },
  methods: {
    goToAllowedArea() {
      if (this.allowedRoute) {
        this.$router.push(this.allowedRoute).catch(() => {});
      }
    }
  }
};
</script>
